import React from "react";
import ProjectCard from "./ProjectCard";
import "./Projects.css";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "framer-motion";

export default function Projects() {
  return (
    <motion.div
      className="projects"
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1,
        delay: 0.1,
        ease: [0.2, 0.41, 0.91, 1],
      }}
      initial={{ opacity: 0, scale: 0.5 }}
    >
      <div>
        <p className="title">My Recent Works</p>
        <p className="description">
          Here are a few projects i've worked on recently
        </p>
      </div>

      <div className="allProjs">
        <ProjectCard
          title={"Parental Control"}
          description={
            "Controls and restrict our children's access to the internet by limiting them to certain categories of content using a system on a Raspberry."
          }
          gitLink={"https://github.com/Younext19/controle_parentale"}
          demo={"https://github.com/Younext19/controle_parentale"}
          img1={"php.png"}
          img2={"js.png"}
          img3={"raspberry.png"}
          mock={"parental_mock.png"}
        />
        <ProjectCard
          title={"Quarto Game"}
          description={
            "Quarto is an outstanding game of deductive reasoning. Line up four pieces which have something in common."
          }
          gitLink={"https://github.com/Younext19/Quatro_Game"}
          demo={"https://github.com/Younext19/Quatro_Game"}
          img1={"react.png"}
          img2={"js.png"}
          img3={"nodejs.png"}
          mock={"quarto_mock.png"}

        />
        <ProjectCard
          title={"HappyM Restaurant"}
          description={
            "A Restaurant website presentation and displaying the menu."
          }
          gitLink={"https://github.com/Younext19/restaurant_ui_react"}
          demo={"https://younext19.github.io/restaurant_ui_react/"}
          img1={"react.png"}
          img2={"js.png"}
          img3={"nodejs.png"}
          mock={"restaurant_mock.png"}

        />
        <ProjectCard
          title={"Riddles App"}
          description={
            "This is an android App where you will find Riddles in all difficulties ( Easy, Medium, Hard )"
          }
          gitLink={"https://github.com/Younext19/Riddles_App"}
          demo={"https://github.com/Younext19/Riddles_App"}
          img1={"java.png"}
          img2={"xml.png"}
          img3={"android.png"}
          mock={"riddles_mock.png"}
          mobile= {true}

       />
        <ProjectCard
          title={"DRF BoilerPlate"}
          description={"Django Rest framework initialized with 0auth2 and CRUD with docker"}
          gitLink={"https://github.com/Younext19/Django-Rest-Boilerplate"}
          demo={"https://github.com/Younext19/Django-Rest-Boilerplate"}
          img1={"python.png"}
          img2={"django.png"}
          img3={"docker.png"}
          mock={"boilerplate_mock.png"}

       />
        <ProjectCard
          title={"Anomaly"}
          description={
            "Report the anomalies that are in the university and notify the responsible"
          }
          gitLink={"https://github.com/Younext19/Anomaly"}
          demo={"https://github.com/Younext19/Anomaly"}
          img1={"js.png"}
          img2={"react.png"}
          img3={"nodejs.png"}
          mock={"anomaly_mock.png"}

     />
        <ProjectCard
          title={"EZ Privacy Policy"}
          description={
            "Want to publish an app ? this generates you a privacy policy which is required for a publish"
          }
          gitLink={"https://github.com/Younext19/PrivacyForm_Generator"}
          demo={"https://github.com/Younext19/PrivacyForm_Generator"}
          img1={"python.png"}
          img2={"selenium.png"}
          img3={"android.png"}
          mock={"privacy_mock.png"}

      />
        <ProjectCard
          title={"Portfolio 😂"}
          description={
            "This is my portfolio to show the works that i've done."
          }
          gitLink={"https://github.com/Younext19/portfolio"}
          demo={"https://github.com/Younext19/PrivacyForm_Generator"}
          img1={"js.png"}
          img2={"react.png"}
          img3={"docker.png"}
          mock={"portfolio_mock.png"}

    />
      </div>
    </motion.div>
  );
}
